module.exports = "<div class=\"snackbar no-print\" [@snack-visibility]=\"snackVisibility\">\n  {{ message }}\n</div>"